// features/rooms — PUBLIC BARREL.
// The Room-Provider join surface (nsi-sales SSO integration, /api/rooms/*).
// Sibling to features/join (the tenant-API-key Meeting model) — separate
// resource, separate auth model, same underlying video engine (features/meet).

export { RoomJoinExperience } from './containers/RoomJoinExperience';
export { RoomNotesForm } from './containers/RoomNotesForm';
export { RoomAnalyticsPage } from './containers/RoomAnalyticsPage';
export { roomsApi } from './api';
export {
  useHostJoinGate,
  useGuestJoinGate,
  useCreateRoom,
  useMyRooms,
  useRoomAnalytics,
  useRoomRecording,
  useRoomTranscript,
  useRoomCallBrief,
  useCorrectDiscovery,
  useSaveRoomNotesDraft,
  useSubmitRoomNotes,
  useRoomPendingAdmissions,
  useDecideRoomAdmission,
} from './hooks';
export { consumeHostAuthFromFragment, resolveHostAuth } from './token';
export { createRoomIdentitySchema } from './validators';
export type { CreateRoomIdentityValues } from './validators';
export type {
  RoomJoinResult,
  RoomJoinGranted,
  RoomJoinWaiting,
  RoomJoinPendingAdmission,
  RoomJoinDenied,
  RoomPendingAdmission,
  RecordingInfo,
  RoomMeetingKind,
  CreateRoomInput,
  CreatedRoom,
  MyRoom,
  RoomListStatus,
  RoomAnalytics,
  RoomAttendee,
  RoomNotesInput,
  RoomRecording,
  RoomTranscript,
  RoomCallBrief,
  RoomScorecard,
  RoomSpeechStats,
  RoomDiscoveryFinding,
} from './types';
